/**
 * Admin Panel Logger
 *
 * Uses the shared logger with admin-specific configuration.
 */

import { createLogger } from '@rekindle/shared/logger';

const isDev = import.meta.env.DEV || import.meta.env.MODE === 'development';

/**
 * Admin panel logger instance
 */
export const logger = createLogger({
  prefix: 'Admin',
  isDev,
  showTimestamp: isDev,
  minLevel: isDev ? 'debug' : 'warn',
});

export default logger;
